<div id="sale-popup-header" class="mat-dialog-title">
    {{ salePopupData?.contentStructureJson.title }}
    <div class="dialog-close-button">
      <a (click)="closeDialog()" id="close">
        <img src="/assets/images/close-popup.png">
      </a>
    </div>
  </div>
  
  <div mat-dialog-content class="salePopUpHeight">
    <img id="generic-image" (click)="cmsMediaClick(salePopupData?.contentStructureJson)"
      src="{{ salePopupData?.contentStructureJson.mediaUrl }}" class="popup-img" (error)="onImageLoadError()" alt="" />
  
  
    <div class="sale-popup-table-responsive table result-container" *ngIf="itemList.length > 0">
      <mat-table #table [dataSource]="itemsData" *ngIf="contentLoaded">
        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef id="item"> Item </th>
          <td mat-cell *matCellDef="let item ; let i=index;" id="item-{{i+1}}" (click)="onProductClick(item)">
            <a>{{item.itemId}}</a></td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef id="description"> Description </th>
          <td mat-cell *matCellDef="let item; let i=index;" id="description-{{i+1}}"> {{item.description}} </td>
        </ng-container>
        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef> Size </th>
          <td mat-cell *matCellDef="let item; let i=index;" id="size-{{i+1}}"> {{item.labelSize}} </td>
        </ng-container>
        <ng-container matColumnDef="form">
          <th mat-header-cell *matHeaderCellDef> Form </th>
          <td mat-cell *matCellDef="let item; let i=index;" id="form-{{i+1}}"> {{item.form}} </td>
        </ng-container>
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef> Price </th>
          <td class="alignment" mat-cell *matCellDef="let item; let i=index;" [ngClass]="{'warn': item.currentPrice === '0l' || item.currentPrice == null || 
          item.currentPrice == undefined || item.currentPrice <= 0}" id="price-{{i+1}}"> {{(item.currentPrice == null || item.currentPrice ==
            undefined ||item.currentPrice
            <= 0 ) ? ( "**" ) : (item.currentPrice| currency)}} </td>
        </ng-container>
        <ng-container matColumnDef="qty">
          <th mat-header-cell *matHeaderCellDef> Quantity </th>
          <td mat-cell *matCellDef="let item; let i=index;" id="qty-{{i+1}}"> <input type="text" maxlength="{{qtyLength}}"
              name="Quantity -{{ i+1}}" id="qty-{{i+1}}" [(ngModel)]="item.cartQuantity" class="text" 
              [ngStyle]="{'border': showItemQtyAlert[item.itemId] ? 'red solid': ''}"
              (ngModelChange)="onItemQuantityChange(item);"
              parNumberOnly/> </td>
        </ng-container>
        <ng-container matColumnDef="addToCart">
          <th mat-header-cell *matHeaderCellDef> Add To Cart </th>
          <td mat-cell *matCellDef="let item; let i=index;" id="addToCart-{{i+1}}"><button type="submit" mat-raised-button
              color="accent" id="btn-add-to-cart" (click)="checkProductBeforeAddToCart(item)" class="add-to-cart">
              Add
            </button> </td>
        </ng-container>
  
        <mat-header-row *matHeaderRowDef="orderColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: orderColumns; let i = index" id="{{i+1}}"></mat-row>
  
      </mat-table>
    </div>
    <div class="qty-alert" *ngIf="showQtyAlert" id="qty-error-msg">
      Please enter the quantity.
    </div>
  <div mat-dialog-actions class="salePopUpClosebutton">
    <button mat-raised-button [mat-dialog-close]="false" id="btn-close" class="close-btn"
      (click)="closeDialog()">Close</button>
    <mat-checkbox id="disable-promotion" name="disablePromotion" [(ngModel)]="disablePromotion">Do not show this week's promotions again
      </mat-checkbox>
  </div>